import { createAction, createAsyncAction } from 'typesafe-actions';
import { JsonDressageProtocolListItem } from './types';

export const fetchDressageProtocols = createAsyncAction(
  'dressages/FETCH_REQUEST',
  'dressages/FETCH_SUCCESS',
  'dressages/FETCH_FAILURE'
)<void, JsonDressageProtocolListItem[], Error>();

export const updateDressageProtocols = createAction('dressages/UPDATE_DRESSAGE_PROTOCOLS', resolve =>
  () => resolve()
);
